import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.scss';
import Login from './pages/Login/Login';
import ForgetPassword from './pages/ForgetPassword/ForgetPassword';
import Signup from './pages/SignUp/Signup'
import Places from './pages/places/Places';
import PlaceDetails from './pages/place details/PlaceDetails';
import Home from './pages/Home/Home';
import { AuthProvider, useAuth } from './Context/AuthContext';
import ConfirmSignUp from './pages/ConfirmSignUp/ConfirmSignUp';
import Otp from './pages/Otp/Otp';
import NewPassword from './pages/Newpassword/Newpassword';
import Favourites from './pages/Favourites/Favourites';
import Nearestplaces from './pages/Nearestplaces/Nearestplaces';
import ProfileSettings from './pages/Profile_settings/ProfileSettings';
import EditInfo from './pages/EditInfo/EditInfo';
import EditPassword from './pages/EditPassword/EditPassword';
import RestEditPassword from './pages/ResetEditPassword/RestEditPassword';
import ChatBot from './pages/ChatBot/ChatBot';
import ThreeDModelViewer from './pages/ThreeDModel/threeDModel'
import TripSuggestion from './pages/TripSuggestion/tripSuggestion';


function App() {

  const { profile } = useAuth();
  const accessToken = localStorage.getItem('accessToken');

  useEffect(() => {

    if (accessToken) {
      profile();
    }

  }, []);
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={<Login />}
          />
          <Route
            path="/forgetpassword"
            element={<ForgetPassword />}
          />
          <Route
            path="/signup"
            element={<Signup />}
          />
          <Route
            path="/places"
            element={<Places />}
          />
          <Route
            path="/"
            element={<Home />}
          />
          <Route
            path="/:placeID/:placeName"
            element={<PlaceDetails />}
          />

          <Route
            path="/nearest-places"
            element={<Nearestplaces />}
          />



          <Route
            path="/confirm-signup"
            element={<ConfirmSignUp />}
          />
          <Route
            path="/forgetpassword"
            element={<ForgetPassword />}
          />
          <Route
            path="/Otp"
            element={<Otp />}
          />
          <Route
            path="/reset-password"
            element={<NewPassword />}
          />
          <Route
            path="/favourits"
            element={<Favourites />}
          />
          <Route
            path="/profile-settings"
            element={<ProfileSettings />}
          />
          <Route
            path="/edit-info"
            element={<EditInfo />}
          />
          <Route
            path="/edit-password"
            element={<EditPassword />}
          />
          <Route
            path="/reset-edit-password"
            element={<RestEditPassword />}
          />
          <Route
            path="/chatbot"
            element={<ChatBot />}
          />

          <Route
            path="/3D-Models"
            element={<ThreeDModelViewer />}
          />

          <Route
            path="/trip-suggestion"
            element={<TripSuggestion />}
          />





        </Routes>
      </Router>
    </AuthProvider>

  );
};

export default App;